export enum DeviceColumns {
    DEVICE = 'Device',
    DEVICE_TYPE_ENUM = 'DeviceTypeEnum'
}